<template>
	<div class="content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">
					<div class="row">
						<div class="col-xl-12" v-if="loading">
							<h2>Loading...</h2>
						</div>
						<div class="col-xl-12" v-if="!loading" v-for="(cost_data, index) in costs_data">
							<h4 class="card-title">Data costs {{index}}</h4>
							<chart-card :key='cost_data' :chart-data="cost_data.data"
										:chart-options="cost_data.options"
										:responsive-options="cost_data.responsiveOptions"
										chart-type="Bar"
							>
								<template slot="footer">
									<div class="legend">
                                        <span v-for="(account,i) in cost_data.account_name">
                                          <i class="fa fa-circle" :style='{color: colors[i]}'></i>{{ account }}
                                        </span>
									</div>
								</template>
							</chart-card>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import ChartCard from 'src/components/Cards/ChartCard.vue'
	import StatsCard from 'src/components/Cards/StatsCard.vue'
	import LTable from 'src/components/Table.vue'
	import axios from 'axios'
	import { colors, formatMoney, formatSimple, chart_base } from 'src/globalVariables'
	import { setInterval } from 'timers';


	Number.prototype.pad = function(size) {
		let s = String(this);
		while (s.length < (size || 2)) {s = "0" + s;}
		return s;
	}

	export default {
		components: {
			LTable,
			ChartCard,
			StatsCard
		},
		async created() {
	      	this.accessToken = await this.$auth.getAccessToken()
			this.loadData();
			let vm = this;
			setInterval(function(){
				vm.loadData();
			},vm.refresh_minutes*60*1000);
		},
		methods: {
			loadData: function(){
				let today = new Date();
				this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2);
				console.log('refreshing...');
				axios
					.get('/business-units/data?access_token=' + this.accessToken)
					.then(response => (this.costs = response.data));
			},
			refresh_costs: function() {
				if (this.costs){
					for (let vendor in this.costs) {
						let [labels, series, account] = [[], [], []];
						let vendorData = this.costs[vendor];
						if (Object.keys(vendorData).length > 0) {
							let cost_by_date = {};
							for (let i in vendorData) {
								if (vendorData[i]['date'] in cost_by_date == false) {
									cost_by_date[vendorData[i]['date']] = [];
								}
								cost_by_date[vendorData[i]['date']].push(vendorData[i]['cost']);

								if (account.includes(vendorData[i]['account']) == false) {
									account.push(vendorData[i]['account']);
								}
							}

							for (let date in cost_by_date) {
								labels.push(date);
								series.push(cost_by_date[date]);
							}

							this.costs_data[vendor] = {
								'account_name': account,
								'data': {
									'labels': labels,
									'series': series
								},
								'options': {
									'stackBars': true,
									'seriesBarDistance': 20,
									'seriesBarWidth': 30,
									'axisX': {
										'showGrid': true,
										'showLabel': true
									},
									'height': '245px',
									'chartPadding': {
										'right': 50,
										'left': 50,
										'bottom': 10,
									},
									'tooltip': {
										'tooltipFnc': function(meta, value) {
											return (value)
										},

										tooltipOffset: {
											x: 10,
											y: 70
										},
										'appendToBody': false,
										'transformTooltipTextFnc': function(value) {
											return formatMoney.format(value)
										}
									},
								},
								'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
							}
						}
					}

					this.loading = false;

				}
			}
		},
		watch: {
			costs:function(){
				this.refresh_costs()
			},
		},
		computed: {

		},
		data () {
			return {
				refresh_minutes: 30,
				last_update: '',
				colors: colors,
				costs: {},
				costs_data: {},
				editTooltip: 'Edit Task',
				deleteTooltip: 'Remove',
				loading: true,
			}
		}
	}
</script>
<style>
	h4.btn {
		background-color: #343a40;
		border-color: #343a40;
		color: #FFFFFF;
	}
</style>
